import { useRouteContext } from '@/app/layouts/TenantLayout'
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuShortcut,
	DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { branding } from '@/config/branding'
import { DOCUMENTATION_LINKS } from '@/config/documentation'
import { shortcut } from '@/lib/shortcuts'
import { cn } from '@/lib/utils'
import { useUser } from '@/stores/authStore'
import { resolveSupportPortalLink } from '@/utils/supportPortal'
import { BookOpen, CircleCheckBig, CircleHelp, Keyboard, MessageCircleQuestion } from 'lucide-react'
import { FOOTER_SQUARE_CLASS } from './footerSquare'

const EXTERNAL = { target: '_blank', rel: 'noopener noreferrer' } as const

export function HelpMenu({ onOpenShortcuts }: { onOpenShortcuts: () => void }) {
	const { orgId } = useRouteContext()
	const user = useUser()

	return (
		<DropdownMenu>
			<Tooltip>
				<TooltipTrigger asChild>
					<DropdownMenuTrigger asChild>
						<button
							type='button'
							aria-label='Help'
							data-testid='sidebar-help-trigger'
							className={cn(
								FOOTER_SQUARE_CLASS,
								'text-muted-foreground hover:text-foreground data-[state=open]:text-foreground',
							)}>
							<CircleHelp className='size-(--icon-standalone)' aria-hidden />
						</button>
					</DropdownMenuTrigger>
				</TooltipTrigger>
				<TooltipContent side='top'>Help</TooltipContent>
			</Tooltip>
			<DropdownMenuContent
				side='top'
				align='start'
				sideOffset={8}
				className='z-100 w-60'
				data-testid='sidebar-help-menu'>
				<DropdownMenuItem asChild>
					<a href={DOCUMENTATION_LINKS.platformGuide.introduction} {...EXTERNAL} data-testid='sidebar-help-docs'>
						<BookOpen aria-hidden />
						Docs
					</a>
				</DropdownMenuItem>
				{orgId && (
					<DropdownMenuItem asChild>
						<a href={resolveSupportPortalLink(user, orgId)} {...EXTERNAL} data-testid='sidebar-support-link'>
							<MessageCircleQuestion aria-hidden />
							Contact support
						</a>
					</DropdownMenuItem>
				)}
				<DropdownMenuItem onSelect={onOpenShortcuts} data-testid='sidebar-help-shortcuts'>
					<Keyboard aria-hidden />
					Keyboard shortcuts
					<DropdownMenuShortcut>{shortcut('Mod-/')}</DropdownMenuShortcut>
				</DropdownMenuItem>
				<DropdownMenuItem asChild>
					<a href={branding.statusUrl} {...EXTERNAL} data-testid='sidebar-help-status'>
						<CircleCheckBig aria-hidden />
						{branding.companyName} status
					</a>
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	)
}
